import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(1).addClass("active");
$(".nei-nav ul li").eq(2).addClass("active");
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    spaceBetween: 24,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 24,
        }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: '.swiper-pagination',
        // 是否可点击----必填项
        clickable: true,
      },
});